import React, { useState, useRef, useEffect } from 'react';
import { useOutsideClick } from '../../utils/useOutsideClick';
import './commonContextMenu.css';

interface ICommonContextMenuProps extends React.PropsWithChildren{
    position: {top: number, left: number}
    boundingElement: HTMLElement;
    className?: string;
    onClose: ()=>void;
}

export const CommonContextMenu = ({position, boundingElement, children, onClose, className = ''}: ICommonContextMenuProps)=>{
    const [side, setSide] = useState('');
    const menuRef = useRef<HTMLDivElement>(null);
    const contextMenuRef = useOutsideClick(onClose);

    useEffect(()=>{
        if (!menuRef.current){
            return;
        }
        const bounding = boundingElement.getBoundingClientRect();
        const menu = menuRef.current.getBoundingClientRect();
        let _side = '';
        if (bounding.right < position.left+menu.width){
            _side += 'r';
        } else {
            _side += 'l';
        }

        if (bounding.bottom > position.top+menu.height){
            _side += 't';
        } else {
            _side += 'b';
        }
       setSide(_side);
    }, [menuRef.current, position]);

    return position && <div ref={contextMenuRef} className="commonContextMenu_position" style={{
            top: position.top, 
            left: position.left
        }}>
        <div 
            ref={menuRef} 
            className={`${className} commonContextMenu commonContextMenu--main ${!side ? "commonContextMenu--hide" : ""} ${"commonContextMenu--"+side}`}
        >
            {children}
        </div>
    </div>
}